import React, { Fragment, Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
// import { Link } from 'react-router-dom';
import classes from './UserMenu.css';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import * as actionCreators from '../../store/actions/index';
import NavigationItem from '../../components/Navigation/NavigationItems/NavigationItem/NavigationItem';

class UserIcon extends Component {
  logoutHandler = () => {
    this.props.Logout();
    this.props.history.push('/');
    this.props.ToggleUserMenu('close');
  }


  render() {

    let menu = null;
    let menuClasses = [classes.Menu, 'userMenu'];
    let iconClasses = [classes.LoginLink];
    if (this.props.showUserMenu) {
      menuClasses.push(classes.showMenu);
      iconClasses.push(classes.LoginLinkActive);
    }

    let icon = <Fragment>
      <div className={iconClasses.join(' ')} onMouseEnter={() => { this.props.ToggleUserMenu('open') }}>
        <FontAwesomeIcon icon={faUser} />

      </div>
    </Fragment>

    if (this.props.token) {
      menu = <div className={menuClasses.join(' ')}>
        <div className={classes.MenuTag}></div>
        <div className={classes.Greeting}>
          <p>Hello,</p>
          <p>{this.props.email}</p>
        </div>
        <Link to='/orders' className={[classes.ListItem, classes.LoggedIn].join(' ')}>
          Account Details
        </Link>
        <Link to='/logout' className={[classes.ListItem, classes.LoggedIn].join(' ')} >
          Log Out
        </Link>
      </div>
    } else {
      menu = <div className={menuClasses.join(' ')} >
        <div className={classes.MenuTag}></div>
        <div className={classes.Greeting}>
          <p>Welcome to Burger Builder!</p>
          <p>Log in or create a new account</p>
        </div>
        <Link to='/authenticate/login' className={[classes.ListItem, classes.LoggedOut].join(' ')}>
          <p>Log in</p>
        </Link>
        <Link to='/authenticate/signup' className={[classes.ListItem, classes.LoggedOut].join(' ')} >
          <p>Sign up</p>
        </Link>
      </div>
    }
    let drawerMenu = <div className={classes.DrawerMenu}>
      <NavigationItem link={'/authenticate/login'} name={'Log in'} openState={this.props.drawerOpen} closeDrawer={() => { this.props.ToggleDrawer('close') }} />
      <NavigationItem link={'/authenticate/signup'} name={'Sign Up'} openState={this.props.drawerOpen} closeDrawer={() => { this.props.ToggleDrawer('close') }} />
    </div>;

    if (this.props.token) {
      drawerMenu = <div className={classes.DrawerMenu}>
        <NavigationItem link={'/orders'} name={'Account Details'} openState={this.props.drawerOpen} closeDrawer={() => { this.props.ToggleDrawer('close') }} />
        <NavigationItem link={'/logout'} name={'Log out'} openState={this.props.drawerOpen} closeDrawer={() => { this.props.ToggleDrawer('close') }} />
      </div>
    }



    return (<Fragment>
      {icon}
      {menu}
      {drawerMenu}
    </Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    email: state.auth.email,
    showUserMenu: state.global.showUserMenu,
    drawerOpen: state.global.drawerOpen
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    Logout: () => dispatch(actionCreators.logout()),
    ToggleUserMenu: (toggleAction) => dispatch(actionCreators.toggleUserMenu(toggleAction)),
    ToggleDrawer: (toggleAction) => dispatch(actionCreators.toggleDrawer(toggleAction))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserIcon));




// WEBPACK FOOTER //
// ./src/containers/UserMenu/UserMenu.jsx